var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var Opcode;
(function (Opcode) {
    Opcode[Opcode["SET_TABLE"] = 0] = "SET_TABLE";
    Opcode[Opcode["PUSH_TAG"] = 1] = "PUSH_TAG";
    Opcode[Opcode["PUSH_NOP"] = 2] = "PUSH_NOP";
    Opcode[Opcode["AND"] = 3] = "AND";
    Opcode[Opcode["OR"] = 4] = "OR";
    Opcode[Opcode["NOT"] = 5] = "NOT";
})(Opcode || (Opcode = {}));
var ValueType;
(function (ValueType) {
    ValueType[ValueType["TAG_ID"] = 0] = "TAG_ID";
    ValueType[ValueType["SET"] = 1] = "SET";
    ValueType[ValueType["TAG_NOP"] = 2] = "TAG_NOP";
})(ValueType || (ValueType = {}));
var TagProgramBuilder = /** @class */ (function () {
    function TagProgramBuilder() {
        this.program = {
            instructions: [],
        };
        this.setTableAdded = false;
    }
    TagProgramBuilder.prototype.addSetTable = function (tagId) {
        this.program.instructions.push({
            opcode: Opcode.SET_TABLE,
            operand: tagId,
        });
        this.setTableAdded = true;
        return this;
    };
    TagProgramBuilder.prototype.addLogicalTagOp = function (tagIds, infixOperation, combineOperation) {
        var e_1, _a, _b;
        if (tagIds.length === 0) {
            return this;
        }
        var instructions = [];
        var count = 0;
        try {
            for (var tagIds_1 = __values(tagIds), tagIds_1_1 = tagIds_1.next(); !tagIds_1_1.done; tagIds_1_1 = tagIds_1.next()) {
                var tagId = tagIds_1_1.value;
                instructions.push({
                    opcode: Opcode.PUSH_TAG,
                    operand: tagId,
                });
                count += 1;
                if (count === 2) {
                    instructions.push({
                        opcode: infixOperation,
                        operand: 0,
                    });
                    count = 1;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (tagIds_1_1 && !tagIds_1_1.done && (_a = tagIds_1.return)) _a.call(tagIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var addCombineOp = this.program.instructions.length > 0;
        (_b = this.program.instructions).push.apply(_b, __spreadArray([], __read(instructions), false));
        if (addCombineOp) {
            this.program.instructions.push({
                opcode: combineOperation,
                operand: 0,
            });
        }
        return this;
    };
    TagProgramBuilder.prototype.build = function () {
        if (!this.setTableAdded) {
            throw new Error('Bad program');
        }
        var prog = this.program;
        this.program = {
            instructions: [],
        };
        this.setTableAdded = false;
        return prog;
    };
    return TagProgramBuilder;
}());
export { TagProgramBuilder };
export function evaluateTagProgram(tagData, program) {
    var e_2, _a;
    var _b;
    var stack = [];
    var acceptedTagIds;
    var _loop_1 = function (instruction) {
        var e_3, _e;
        switch (instruction.opcode) {
            case Opcode.SET_TABLE: {
                var tagId = instruction.operand;
                var accepted = tagData.acceptedTagIds.get(tagId);
                var ids = ((_b = tagData.tagsByParentId[tagId]) === null || _b === void 0 ? void 0 : _b.map(function (t) { return t.id; })) || [];
                stack.push({
                    type: ValueType.SET,
                    set: new Set(ids),
                });
                acceptedTagIds = accepted;
                break;
            }
            case Opcode.PUSH_TAG: {
                var tagId = instruction.operand;
                if (acceptedTagIds && acceptedTagIds.has(tagId)) {
                    stack.push({
                        type: ValueType.TAG_ID,
                        tagId: instruction.operand,
                    });
                }
                else {
                    stack.push({
                        type: ValueType.TAG_NOP,
                    });
                }
                break;
            }
            case Opcode.PUSH_NOP: {
                stack.push({
                    type: ValueType.TAG_NOP,
                });
                break;
            }
            case Opcode.AND: {
                var op1 = stack.pop();
                if (!op1) {
                    throw new Error('Stack empty');
                }
                var op2 = stack.pop();
                if (!op2) {
                    throw new Error('Stack empty');
                }
                var set1 = void 0;
                if (op1.type === ValueType.SET) {
                    set1 = op1.set;
                }
                else if (op1.type === ValueType.TAG_ID) {
                    set1 = tagData.downstreamTagIds.get(op1.tagId);
                    if (!set1) {
                        set1 = new Set();
                    }
                }
                else if (op1.type === ValueType.TAG_NOP) {
                }
                var set2 = void 0;
                if (op2.type === ValueType.SET) {
                    set2 = op2.set;
                }
                else if (op2.type === ValueType.TAG_ID) {
                    set2 = tagData.downstreamTagIds.get(op2.tagId);
                    if (!set2) {
                        set2 = new Set();
                    }
                }
                else if (op1.type === ValueType.TAG_NOP) {
                }
                if (set1 && set2) {
                    var result = new Set();
                    var smallerSet = set1.size < set2.size ? set1 : set2;
                    var largerSet = set1.size < set2.size ? set2 : set1;
                    try {
                        for (var smallerSet_1 = (e_3 = void 0, __values(smallerSet)), smallerSet_1_1 = smallerSet_1.next(); !smallerSet_1_1.done; smallerSet_1_1 = smallerSet_1.next()) {
                            var tagId = smallerSet_1_1.value;
                            if (largerSet.has(tagId)) {
                                result.add(tagId);
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (smallerSet_1_1 && !smallerSet_1_1.done && (_e = smallerSet_1.return)) _e.call(smallerSet_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    stack.push({
                        type: ValueType.SET,
                        set: result,
                    });
                }
                else if (!set1 && !set2) {
                    stack.push({
                        type: ValueType.TAG_NOP,
                    });
                }
                else if (set1 && !set2) {
                    stack.push({
                        type: ValueType.SET,
                        set: new Set(set1),
                    });
                }
                else if (!set1 && set2) {
                    stack.push({
                        type: ValueType.SET,
                        set: new Set(set2),
                    });
                }
                break;
            }
            case Opcode.OR: {
                var op1 = stack.pop();
                if (!op1) {
                    throw new Error('Stack empty');
                }
                var op2 = stack.pop();
                if (!op2) {
                    throw new Error('Stack empty');
                }
                var set1 = void 0;
                if (op1.type === ValueType.SET) {
                    set1 = op1.set;
                }
                else if (op1.type === ValueType.TAG_ID) {
                    set1 = tagData.downstreamTagIds.get(op1.tagId);
                }
                else if (op1.type === ValueType.TAG_NOP) {
                }
                var set2 = void 0;
                if (op2.type === ValueType.SET) {
                    set2 = op2.set;
                }
                else if (op2.type === ValueType.TAG_ID) {
                    set2 = tagData.downstreamTagIds.get(op2.tagId);
                }
                else if (op1.type === ValueType.TAG_NOP) {
                }
                var result_1 = new Set();
                if (set1) {
                    set1.forEach(function (id) { return result_1.add(id); });
                }
                if (set2) {
                    set2.forEach(function (id) { return result_1.add(id); });
                }
                stack.push({
                    type: ValueType.SET,
                    set: result_1,
                });
                break;
            }
            case Opcode.NOT: {
                break;
            }
            default: {
                break;
            }
        }
    };
    try {
        for (var _c = __values(program.instructions), _d = _c.next(); !_d.done; _d = _c.next()) {
            var instruction = _d.value;
            _loop_1(instruction);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_2) throw e_2.error; }
    }
    if (stack.length !== 1) {
        console.log(program);
        throw new Error('Stack length not 1, instead: ' + stack.length);
    }
    var res = stack[0];
    if (res.type === ValueType.SET) {
        return res.set;
    }
    else if (res.type === ValueType.TAG_ID) {
        return new Set(tagData.downstreamTagIds.get(res.tagId));
    }
    else {
        return new Set();
    }
}
